import { useEffect, useState } from "react";
import { parseCSV } from "utils/csvParser";
import {Charles} from "types/index";

const SHEET_ID = '1Pn2uhmu_jDx9Gtdp-IUq8idBVJ1h2xCRC1FJXBQaZss'
const SHEET_ANSWER_TITLE = 'SortedSheet';
const SHEET_FEEDBACK_TITLE = 'SortedFeedbackSheet';
const SHEET_ANSWER_RANGE = (nbOfAnswers: number = 20) => `A1:D${nbOfAnswers}`;

const defaultAnswers: Charles.Answer[] = [
  {
    date: '2023-11-17T15:59:08.950Z',
    score: 10,
    feedBack: "Pratique quand on habite exentré de tout ; convivial sur des questions aussi intimes ; assurance de l'expertise puisque s'inscrivant dans la dynamique des vidéos du dr Gilbert BS.",
    firstName: 'Frédéric'
  },
  {
    date: '2023-11-16T09:03:45.809Z',
    score: 10,
    feedBack: "Très bien service, rapide et professionnel.\n Merci",
    firstName: 'Tony'
  },
  {
    date: '2023-11-15T09:23:12.818Z',
    score: 10,
    feedBack: "Docteur à l’écoute et très pédagogue.",
    firstName: 'Olivier'
  }
]

export const getUrl = (title: string, range: string) => {
  return ('https://docs.google.com/spreadsheets/d/' + SHEET_ID + '/gviz/tq?tqx=out:csv&sheet=' + title + '&range=' + range);
}

export const useSatismeterAnswers = (feedBackOnly = false, numberOfAnswers = 3 ) => {
  const [answers, setAnswers] = useState<Charles.Answer[]>(defaultAnswers);

  const fetchAnswers = async () => {
    fetch(getUrl(feedBackOnly ? SHEET_FEEDBACK_TITLE : SHEET_ANSWER_TITLE, SHEET_ANSWER_RANGE(numberOfAnswers + 1)))
      .then(res => res.text())
      .then(rep => {
        const data = parseCSV(rep)
        const cleanedAnswers = data.map((d: string[]) => {
          return {
            date: d[0],
            score: Number(d[1]) /2,
            feedBack: d[2],
            firstName: d[3]
          }
        }).slice(1);
        setAnswers(cleanedAnswers);
      })
      .catch((e) => {
        console.error(e);
      })
  }

  const reload = () => {
    fetchAnswers();
  }

  useEffect(() => {
    fetchAnswers();
  }, []);

  return { answers, reload }
}

